

export const TYPES = {
    ALL: "ALL",
    REQUESTED: "REQUESTED",
    IRSEN: "IRSEN",
    CONFIRM: "CONFIRM",
    REJECTED: "REJECTED",
}


export const LEASING_TYPES = {
    N: "N",
    Y: "Y",
    R: "R",
}